export default __webpack_public_path__ + "static/media/calendar.c1630c64.svg";